module.exports = __webpack_public_path__ + "media/images/simulation/ic_share-32135ff20c57193f2493a19cf2e0bc0c.svg";